import {Component} from '@angular/core';
/**
 * \@title Basic tabs
 */
export class TabsOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'tabs-overview-example',
  templateUrl: 'tabs-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TabsOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
TabsOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TabsOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
